import RSSerializableBase from 'lumen/serializers/rsserializable';

export default class RSSubtypeSerializer extends RSSerializableBase {}
